import {Game} from "@game/game";
import {TileView} from "@components/interface/TileView";
import {CSSProperties} from "react";
import {Vector2} from "@utility/vector2";
import {selectOffset} from "@redux/selectors/map";
import {connect} from "react-redux";
import {update as updateMap} from "@redux/slices/map";
import {LETTER_THEME, TILE_SIZE} from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    content: {
        ...LETTER_THEME.container,
        alignItems: "center",
        backgroundColor: "white",
        boxShadow: "8px 8px 8px rgba(0, 0, 0, 0.5)",
        filter: "drop-shadow(8px, 8px)",
        justifyContent: "center",
        margin: 2,
        position: "fixed",
        touchAction: "none",
        transform: "scale(1.05)",
        zIndex: 1000
    },
    drop: {
        backgroundColor: "rgba(0, 0, 0, 0,5)",
        borderRadius: 4,
        position: "absolute",
        height: TILE_SIZE.y,
        width: TILE_SIZE.x
    },
    letter: {
        ...LETTER_THEME.content,
        pointerEvents: "none"
    }
};

interface ITileController {
    dragging: boolean
    position: Vector2
    game: Game
}
function DraggedTileController({dragging, position, game}: ITileController) {
    const content = {
        ...styles.content,
        display: dragging ? "flex" : "none",
        left: position.x,
        top: position.y,
    }

    return (
        <div data-draggable="draggedTileController" style={content}>
            {game.userPlayer?.hand.dragging &&
                <TileView dragging={true} letter={game.userPlayer.hand.dragging}/>
            }
        </div>
    );
}
const mapStateToProps = (store: never) => ({
    mapOffset: selectOffset(store)
});
const connected = connect(mapStateToProps, {
    updateMap
})(DraggedTileController);

export {connected as DraggedTileController}
